const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson1WhatYouWillDo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.39,142.67c-1.64,4.18-4,8-5.28,12.31A28.25,28.25,0,0,0,369,167.3c2.32,15.15,22.05,24.24,35.9,19.54,6.63-2.26,12.4-7.63,14.16-14.53,2.15-8.45-2.36-16.57-5.1-24.29a39.5,39.5,0,0,1-2.22-13.45c0-4,.24-8.09-.57-12-.58-2.82-2.51-11-12.91-14.31-7.47-2.35-15,1.73-18.51,8.82C375.73,125.27,378.62,134.39,375.39,142.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,143.91c3.23,6.91,7.46,14,8.71,21.59,1,6.32-.68,13.16-6.18,16.92-.05,0-.1,0-.06-.07,5.78-4.47,6.5-12.22,4.88-18.87-1.66-6.83-5.66-12.76-7.68-19.43A.18.18,0,0,1,411,143.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.42,143.51c2.44,9.06,9.9,16.2,10.38,25.84,0,.12-.17.14-.18,0-.63-9.63-8.92-16.47-10.38-25.85C412.22,143.41,412.39,143.4,412.42,143.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.86,142.52a31.27,31.27,0,0,0,2.84-10.65c0-.19.33-.21.34,0,.87,13.31-14.37,23.28-10.31,37,0,.1-.11.16-.15.07-1.95-5.68-.43-11.36,2.12-16.59C371.32,149,373.29,145.89,374.86,142.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,129.89c0-.25.4-.18.38.07a29.71,29.71,0,0,1-4.67,14c-1.33,2.07-3,3.93-4.24,6-1.4,2.3-2.48,4.77-3.66,7.19,0,.06-.12,0-.1,0,1.54-4.58,3.94-8.23,6.69-12.13A32.68,32.68,0,0,0,378,129.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.25,158.88c0,21.65-2.46,43.6-5.49,47.41-4.69,5.91-33.7,17.28-43.32,19.08-3.15.58-8.81-20.49-6.56-23.08s33.7-12.52,35.34-13.83c.87-.71,6.49-18.13,11-29.9C390.48,147.62,395.25,152.31,395.25,158.88Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,223.29l-7.51-26.55s22.12-8.24,24.75-9.48c1.11-.52,8.18-22,11.72-31.35,2.33-6.12,8.45-8.82,9.85,3.74.82,7.36-.42,42.61-5.49,48.14C386.57,212.19,357.28,223.29,357.28,223.29Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.13,218.56c-.14-1.8-5.13-19.52-5.63-21.34,0-.1-.18-.08-.16,0A156.29,156.29,0,0,0,362,218.59.05.05,0,0,0,362.13,218.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.6,207.79c-2.38,2.59-13.54,7.52-22.3,11.13l1.4-29.72c2.37-.92,4.17-1.64,4.82-1.94,1.11-.52,8.18-22,11.72-31.35,2.33-6.12,8.45-8.82,9.85,3.74C396.91,167,395.67,202.26,390.6,207.79Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.3,471.26c2.42.76,73.13-.77,75.71-2.5,1-.63-5.06-67.61-5.06-67.61L348.1,402l5.1,44.8s-26.09,12.36-28.73,14.55S319.88,470.51,322.3,471.26Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.3,471.26c2.42.75,73.13-.77,75.71-2.5.31-.19.4-7-.72-15.85-12.82,2.15-58.59,9.18-62.15,7.08-2.48-1.46-.28-3.74,1.75-5.28-5.84,2.91-11.29,5.71-12.42,6.66C321.85,463.55,319.88,470.51,322.3,471.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,468.76c-1.3.88-20.08,1.7-38.61,2.2l37.05-29C397.57,456.08,398.43,468.49,398,468.76Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.94,436.07l44-.62S386.13,335,386.49,333c.46-2.6,32.81-130.06,32.81-130.06h-42S344.15,317.07,343,328.07C341,345.83,351.94,436.07,351.94,436.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,425.51c-2.6-.19-5.23-.15-7.83-.19s-5.23,0-7.84,0c-5.22.06-10.44.13-15.66.28l-4.28.15c-1.53.07-3.05.33-4.57.39-.12,0-.11.18,0,.19,1.28,0,2.56.2,3.84.24s2.67,0,4,0l7.83,0c5.22,0,10.44-.11,15.65-.33,3-.12,5.93-.16,8.86-.45A.14.14,0,0,0,392,425.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.06,212.81c-3.76,13.32-7.2,26.75-10.57,40.16s-6.72,26.85-10.06,40.29l-5,20.14c-1.63,6.54-3.52,13.11-3.92,19.87s.46,13.79,1,20.63,1.16,13.75,1.76,20.62c1.2,13.75,2.36,27.51,3.86,41.24.18,1.71.37,3.43.54,5.15,0,.14.24.14.23,0-.91-13.76-1.86-27.51-3-41.25-.54-6.88-1.11-13.75-1.67-20.63s-1.37-13.74-1.59-20.62,1.05-13.6,2.73-20.31,3.29-13.14,4.94-19.71q5-20.14,10.06-40.29c3.73-15,7.45-30.1,10.74-45.25A.06.06,0,0,0,410.06,212.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.3,202.92s-13.24,52.34-22.62,89.33l-18-89.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1,471.42c2.43.76,73.13-.77,75.71-2.49,1-.64-3.69-67.65-3.69-67.65l-43.26.86L405,447s-26.08,12.36-28.73,14.56S371.68,470.67,374.1,471.42Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1,471.42c2.42.76,73.13-.77,75.71-2.5.31-.19.24-6.81,0-15.85-12.82,2.14-59.29,9.18-62.86,7.08-2.48-1.46-.28-3.74,1.75-5.28-5.84,2.92-11.29,5.72-12.42,6.66C373.65,463.71,371.68,470.68,374.1,471.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.64,202.91s2.38,29.7,7.28,37.16a75,75,0,0,1,12.18,6.07s3,79.47,3,84.24c-.19,17.85,4.37,104.81,4.37,104.81l44.39-.43s-11.49-151.09-14.17-185.68c0,0,2-11.05,1.59-16.63-1.06-13.53-6.17-29.53-6.17-29.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.26,231.15c-.16-1.11-.33-2.22-.5-3.33-.31-2-.73-4.06-1.08-6.09-.81-4.6-1.65-9.22-2.68-13.78a.1.1,0,0,0-.2,0c.18,1.84.39,3.68.66,5.51s.44,3.68.7,5.52c.51,3.63,1,7.28,1.63,10.9.24,1.39,1.11,3.89-.89,4.32-1.59.35-2.76-1.22-3.23-2.52a31.92,31.92,0,0,1-1.07-5c-.32-1.83-.61-3.68-.87-5.52q-.86-6-1.85-12c0-.11-.2-.08-.2,0,.13,4.13.35,8.22.89,12.32.26,2,.55,3.91.89,5.86a20.71,20.71,0,0,0,1.34,5.45,4.43,4.43,0,0,0,3.32,2.67h.1a.14.14,0,0,0-.06.12c0,.65,0,1.31.08,2s.19,1.28.31,1.92a13.74,13.74,0,0,0,.5,1.91,5.5,5.5,0,0,0,.87,1.69.12.12,0,0,0,.22-.07h0c0-.11,0-.21,0-.32s0,0,0,0h0a5.44,5.44,0,0,0,0-.57c-.05-.32-.12-.63-.19-.94-.14-.62-.31-1.23-.47-1.85s-.3-1.23-.46-1.84-.37-1.25-.51-1.89c0,0,0,0-.05-.06a2.89,2.89,0,0,0,2.8-1.76A5,5,0,0,0,393.26,231.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.69,247.11a36.18,36.18,0,0,0-4.17-2.75,41.21,41.21,0,0,0-4.76-2.46c-3.21-1.4-6.52-2.35-9.84-3.45-.1,0-.16.14-.07.17,3.21,1.28,6.29,3,9.39,4.49,1.53.75,3.07,1.46,4.63,2.15s3.1,1.49,4.7,2.07C400.69,247.38,400.79,247.19,400.69,247.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.9,222.31c-2.25,0-10.07-.57-12.38-3.16a15.82,15.82,0,0,1-2.89-5.21,47.85,47.85,0,0,1-1.75-6.33.09.09,0,0,0-.18,0,24.2,24.2,0,0,0,.91,7.18c.54,2,1.28,4.2,2.88,5.59a11.31,11.31,0,0,0,6.13,2.24,28.24,28.24,0,0,0,7.29-.1A.12.12,0,0,0,421.9,222.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,222.92a7.57,7.57,0,0,0,3-1.81c1.71-2.57,2.13-10.74,2.27-12.89,0-.11.06-.07.06,0,0,2.4-.09,4.86-.28,7.18a26.07,26.07,0,0,1-.89,5.59c-.52,1.46-3.4,2.47-4.15,2.14C372.29,223.14,372.29,222.92,372.34,222.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.87,426.16c-2.6-.18-5.23-.15-7.84-.19s-5.22,0-7.83,0c-5.22.05-10.44.13-15.66.27-1.43,0-2.86.09-4.28.15s-3.05.34-4.58.39a.1.1,0,0,0,0,.19c1.28,0,2.56.2,3.85.24s2.66,0,4,0c2.61,0,5.22,0,7.83,0,5.22,0,10.44-.11,15.66-.33,2.94-.12,5.92-.15,8.85-.45A.14.14,0,0,0,446.87,426.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.45,420.38h0a.53.53,0,0,0,.51-.57L428.12,247.75c.13-.76,2.95-10.37,3.21-15.28.26-5.19-5.1-25.42-5.33-26.27a.55.55,0,0,0-.66-.39.54.54,0,0,0-.39.66c.06.21,5.55,20.93,5.3,25.95s-3.19,15.12-3.2,15.2,13.86,172.25,13.86,172.25A.54.54,0,0,0,441.45,420.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.49,194.19l-2.14,16.37,57.78-2s-15.33-45.71-24.57-54.83c-7.35-7.25-15.53-6.29-20.5-.74-1.26,1.41-13.63,21.36-14.91,29.41C373,189.52,378.49,194.19,378.49,194.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.45,191.92a22,22,0,0,0-5.47.69c-.91.26-1.83.58-2.74.94-.46.18-.91.33-1.37.48a3.79,3.79,0,0,1-1.42.24s-.06.1,0,.11a5.72,5.72,0,0,0,1.3.17,6.55,6.55,0,0,0,1.3-.22c.93-.24,1.86-.56,2.79-.82a50.06,50.06,0,0,1,5.61-1.33C390.51,192.17,390.54,191.91,390.45,191.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.9,194a54.12,54.12,0,0,0-7-.43c-1.16,0-2.32.09-3.48.21-.56.06-1.11.12-1.66.2s-1.21.26-1.82.34c-.06,0-.06.12,0,.11.58,0,1.16,0,1.74,0l1.74,0,3.48-.07c2.33-.07,4.64-.12,7-.1C399,194.2,399,194,398.9,194Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.34,148.86S395.23,185,395,187.77s-7.5,72.7,7.24,89.59c8.14,9.33,38.7,13.45,38.7,13.45s-1.42-53.93-3.45-67.77c-1.95-13.23-12.42-46.83-24.06-65C409.23,151.44,405.36,149.61,401.34,148.86Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.83,245.42c-.15,5.66.13,12.07,1.34,13.24,2.27,2.2,8.28,2,10.16,2s8.62-.06,10.18-3.53c.69-1.54.85-9.44.82-12.24,0-1.14-.29-6.73-.38-7.35,0-.15-.42-.13-.43,0-.1.64,0,3-.06,3.4a62.72,62.72,0,0,1-21-.36c0-1.05,0-1.86,0-2.91a59.2,59.2,0,0,0,10.27.94,111.71,111.71,0,0,0,11.25-.85c.09,0,0-.43-.11-.42-1.41,0-6.3.52-11.23.54a89.23,89.23,0,0,1-10.54-.78C405.89,237.09,405.91,242.7,405.83,245.42Zm2,12.59c-1.21-1.37-1.37-5.32-1.38-7.68,0-3.26,0-5.86,0-9.12a55.73,55.73,0,0,0,21,.2c0,.14.09,7,0,9.2-.07,2.8-.15,5.32-1.22,6.78-.91,1.25-3.5,2.51-9.47,2.53C412.47,259.93,408.83,259.16,407.83,258Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,153S381,173.21,380,179.49a86.43,86.43,0,0,0-.52,14.78s-7.51,63.63-9.26,68.89-16.12,16.94-16.12,16.94,15.39-52.64,19.74-69.18c1.09-4.13,2.19-17,2.19-17s-3.45-3.91-2.68-10.85S385,158.32,389.06,153Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.47,152.58c-.76,1.17-4.67,12.34-4,12.92s10.65,1.05,11.67.37,3.65-14.11,3.6-15S389.47,152.58,389.47,152.58Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.77,150.89c-.13,1.05-4.35,8.26-9.09,8.53-1.54.09-2.38-8.31-2.38-8.31l-.21-.61L386.24,142l9.51-7.61,1.39-1s.62,2.37,1.38,5.33c0,.13.07.27.1.42a4.94,4.94,0,0,1,.13.48c.12.44.24.89.35,1.34s.16.68.24,1l.24,1.08A57.54,57.54,0,0,1,400.77,150.89Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.52,138.73a17.92,17.92,0,0,1-9.43,11.77L386.24,142l9.51-7.61,1.39-1S397.76,135.77,398.52,138.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.49,125.49c-3.79,15.24,4.91,19.23,8.19,20,3,.74,13.24,2.87,18.58-11.89s-.54-21.33-7.27-23.38S378.28,110.26,374.49,125.49Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.19,124.76c.37,0,.71,0,1.08,0a1.81,1.81,0,0,0,1.1-.25.55.55,0,0,0,.11-.67,1.36,1.36,0,0,0-1.28-.56,2,2,0,0,0-1.39.49A.6.6,0,0,0,377.19,124.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.59,126.2a8.89,8.89,0,0,1-1-.41,1.74,1.74,0,0,1-.95-.6.55.55,0,0,1,.12-.67,1.38,1.38,0,0,1,1.4-.09,2,2,0,0,1,1.13.93A.6.6,0,0,1,387.59,126.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,127.69s-.09,0-.09.08c-.13,1.06-.45,2.26-1.46,2.47,0,0,0,.06,0,.06C378.63,130.31,379,128.72,379,127.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,126.45c-1.68-.39-2.33,3-.78,3.36S379.63,126.77,378.22,126.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.47,126.53c-.3.13-.63.41-1,.37s-.58-.47-.75-.87c0,0,0,0-.06,0-.14.64-.06,1.36.54,1.6s1.07-.25,1.35-.86C377.65,126.68,377.59,126.48,377.47,126.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.14,128.9s.08.07.07.11c-.22,1.05-.29,2.28.6,2.8,0,0,0,.07,0,.06C384.66,131.5,384.77,129.86,385.14,128.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.28,128c1.71.16,1.25,3.58-.34,3.43S384.84,127.83,386.28,128Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,128.29c.24.22.47.58.79.65s.69-.26,1-.59c0,0,0,0,0,.05-.07.65-.38,1.31-1,1.35s-.94-.58-1-1.25C386.74,128.37,386.86,128.2,387,128.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.91,137.47c-.26.24-.53.58-.92.6a2.91,2.91,0,0,1-1.14-.32s-.06,0,0,.06a1.43,1.43,0,0,0,1.33.63,1.16,1.16,0,0,0,.88-.92C384,137.46,384,137.44,383.91,137.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.83,133.21s-.37,1.56-.44,2.31c0,.07.17.12.42.16h0a3.58,3.58,0,0,0,3.59-1c.06-.07,0-.15-.1-.11a5.42,5.42,0,0,1-3.34.62c0-.21.72-2.66.6-2.68a6.53,6.53,0,0,0-1.74.22c.68-3.29,1.87-6.44,2.5-9.73,0-.11-.15-.17-.19-.06A54.45,54.45,0,0,0,378,133.3C377.92,133.72,379.52,133.3,379.83,133.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.92,135.41a4.36,4.36,0,0,0,1.5,1.6,1.91,1.91,0,0,0,1.16.25c.88-.09,1-.86,1-1.55a4.64,4.64,0,0,0-.22-1.08A5.55,5.55,0,0,1,379.92,135.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.42,137a1.91,1.91,0,0,0,1.16.25c.88-.09,1-.86,1-1.55A2,2,0,0,0,381.42,137Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,134.49a6.48,6.48,0,0,1-3.11-5.61,16.92,16.92,0,0,1-6.34-6.18c.08.33.61,2.73.92,4-9.76-2.81-12.11-10.71-12.11-10.71a17.33,17.33,0,0,0-4.94,5.88s.51-6.1,4-9.89a9.88,9.88,0,0,1,9.46-3.18,14.11,14.11,0,0,1,13.32,5.54C408.14,122,401.12,134.49,401.12,134.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.19,124.28a18.59,18.59,0,0,0,4.92,2.36s0,0,0,0a15.66,15.66,0,0,1-6.88-5.11,14.64,14.64,0,0,1-1.85-3.21,10,10,0,0,1-1-3.91c0-.1-.16-.1-.16,0a12,12,0,0,0,.42,4,10.91,10.91,0,0,0,1.89,3.5,12.65,12.65,0,0,0,2.61,2.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.55,134.21s4.15-4.3,6.15-2.75-1.65,8.17-4.38,8.72a2.65,2.65,0,0,1-3.29-2Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.61,133.33s0,.07,0,.07c-1.92.45-3.14,2-4.08,3.61a1.46,1.46,0,0,1,2.23,0s0,.1-.07.08a1.63,1.63,0,0,0-1.86.29,7.54,7.54,0,0,0-1.08,1.3c-.11.14-.39,0-.3-.16l0,0C398.79,136.11,401.1,133.17,403.61,133.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.19,162.32c6.08,16.72,11.61,44.44,8.24,49-8.43,11.35-25.93,21.91-33.8,25.06-4.59,1.84-15.49-21.93-11.49-23.76,6.31-2.9,23.36-13.57,25.44-15,1.11-.79.92-19.83,1.93-32.27C404.62,151.75,410.23,154.18,413.19,162.32Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.71,223.37c1.11-1.29.43-1.88-2.54-1.29s-14.22,5.45-15.58,1.38,14.61-10.7,19.63-11.3,13.36.17,13.36.17C375.73,214.24,369.25,219.55,363.71,223.37Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.39,
    y: 193.82,
    width: 8.83,
    height: 55.48,
    transform: "translate(774.32 198.53) rotate(144.94)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.56 267.03 390.48 259.36 390.48 259.36 369.81 229.91 369.81 229.91 358.89 237.57 358.89 237.57 379.56 267.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297,199.39a48.26,48.26,0,1,1,36.76-2.85A48.24,48.24,0,0,1,297,199.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.44,207.13a56.33,56.33,0,1,1,71-36A56.4,56.4,0,0,1,294.44,207.13Zm2-6.14a49.87,49.87,0,1,0-31.92-62.89A49.93,49.93,0,0,0,296.45,201Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.12,147.42a51.84,51.84,0,0,0-5.24-17.15,51.24,51.24,0,1,0,5.24,17.15Zm-5.38,21.14a48.24,48.24,0,1,1-2.85-36.77A48.24,48.24,0,0,1,357.74,168.56Zm5.38-21.14a51.84,51.84,0,0,0-5.24-17.15,51.24,51.24,0,1,0,5.24,17.15Zm-5.38,21.14a48.24,48.24,0,1,1-2.85-36.77A48.24,48.24,0,0,1,357.74,168.56Zm11.79-21.91a58,58,0,1,0-2.46,24.95A57.85,57.85,0,0,0,369.53,146.65Zm-5.65,23.91a54.66,54.66,0,1,1,2.31-23.5A54.3,54.3,0,0,1,363.88,170.56Zm-6-40.29a51.24,51.24,0,1,0,5.24,17.15A51.84,51.84,0,0,0,357.88,130.27Zm-.14,38.29a48.24,48.24,0,1,1-2.85-36.77A48.24,48.24,0,0,1,357.74,168.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.49,169.7A37.12,37.12,0,0,1,272,154.78a39.82,39.82,0,0,1,.53-7.84,42.07,42.07,0,0,1,2.12-7.66,38.43,38.43,0,0,1,8.8-13.24,42.62,42.62,0,0,1,13-8.75,76.47,76.47,0,0,0-11.13,10.46A47,47,0,0,0,281,133.8a38.69,38.69,0,0,0-3.27,6.61,47.48,47.48,0,0,0-3.16,14.35A62.77,62.77,0,0,0,275.49,169.7Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,150a37,37,0,0,1-.74,15.3,38.9,38.9,0,0,1-2.65,7.4,41.44,41.44,0,0,1-4.13,6.79,38.47,38.47,0,0,1-12.08,10.34,42.68,42.68,0,0,1-14.91,4.85,76.48,76.48,0,0,0,13.56-7,47.84,47.84,0,0,0,5.82-4.65,38.81,38.81,0,0,0,4.95-5.46,47.37,47.37,0,0,0,6.95-12.94A62.63,62.63,0,0,0,350,150Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.29,234.74c-8.23,5.1-18.16,11.95-29.08,12.19a5.43,5.43,0,0,1-3.4-1c-4.89.19-6.45-2.06-6.45-2.06-4.61-1.21-5.9-3.73-5.9-3.73s-5.74.17-6.42-3.28c-.77-3.87,7.45-3.36,12.14-5.83,10.76-5.68,24.46-16.76,27.4-18.71Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.64,233a78.52,78.52,0,0,1-9.7,4.43,78.06,78.06,0,0,1-11.4,2.6.1.1,0,0,0,0,.19,41.26,41.26,0,0,0,21.14-7.08C366.85,233.05,366.8,232.93,366.64,233Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,239c-3.2,1.39-8.84,3.8-19.66,4.77,0,0,0,.06,0,.06a37.07,37.07,0,0,0,19.73-4.68C371.27,239.05,371.22,238.91,371,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3,242.27c-5.53,2.16-9.29,2.82-15.47,3.64,0,0,0,.07,0,.06,7.12-.19,9.68-1.07,15.57-3.53C373.6,242.36,373.51,242.18,373.3,242.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,238.35l-14.76-28.69L400.41,197c.27-10.26.81-30.78,2.06-37.85,1.46-8.3,7.32-7.82,10.76,0,7.89,18,12.31,47.35,10.83,52C421.93,217.91,393,238.35,393,238.35Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.83,232.4c-.58-1.94-4.27-9.43-5.21-11.29s-5-9.17-5.93-11.08c-.05-.1-.21-.06-.16.05.93,1.9,4.38,9.54,5.3,11.41s4.69,9.3,5.9,10.95C395.78,232.5,395.85,232.46,395.83,232.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.46,172.55c-.09,6.91-.09,14.95-.38,21.89a26.06,26.06,0,0,1-.19,2.62.69.69,0,0,1-.25.41c-5.2,3.44-11.31,6.41-16.82,9.36l-5.59,2.82,0-.06.34.8-.42-.76,0,0,.05,0,5.39-3.17c5.28-3.14,11.35-6.31,16.42-9.65,0,0,0,0,0,0a.3.3,0,0,0-.07.14c0-.29.06-.6.08-.94.43-7.64.52-15.8,1.44-23.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.62,173.84a34.35,34.35,0,0,1,.59,3.49,7.58,7.58,0,0,1-.59-3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,234.77l1.93,3.54-.15,0c8.51-5.91,16.88-12.1,24.29-19.34a39.62,39.62,0,0,0,6.42-8,3.65,3.65,0,0,0,.26-1.07c.45-6.43-.85-12.86-1.87-19.19-1.24-6.79-2.85-13.53-4.66-20.21a175.7,175.7,0,0,1,5.39,20.07C424,197,425.26,203.5,424.86,210a4.39,4.39,0,0,1-.37,1.43,38,38,0,0,1-6.63,8.13A152.12,152.12,0,0,1,393,238.44l-.1.06-.05-.1-1.75-3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.67,172.69a8.33,8.33,0,0,1,.42,3.83c-.15-1.28-.34-2.53-.42-3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.89,217.26c-.78-3.23-4.13-.47-4.13-.47s3.87-5.14,1.78-8.16-6,.58-6.24.83c.2-.28,3.64-5.1,1.23-7.92s-5.87,1.25-6.08,1.52c.11-.31,1.49-4.55-.83-6.28-4-3-9,8.82-12.66,10.39l-6.51-3.7a10,10,0,0,1,1.65,5.41c.11,2.77.17,4.63,1,6.15a3.64,3.64,0,0,0,3.9,1.9s-1.61,3.13.22,5.41c.94,1.17,3.65.7,3.65.7a4.36,4.36,0,0,0,.57,4.49c1.39,1.54,3.89.83,3.89.83s0,3,1.94,4.1C342.19,234.7,356.55,224.17,354.89,217.26Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.33,206.55l-4.76-3c-.2-.07-.41-.15-.6-.2-6.89-2.06-14.48,3.17-10.17,6,3.28,2.16,9.37-.54,12.4,2.15h0Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.76,228.31a0,0,0,1,0,0,.08A30.86,30.86,0,0,0,351,216.66c.11-.17-.12-.41-.27-.24A63.6,63.6,0,0,1,336.76,228.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.84,223.12c-.06,0,0,.14.07.11a29,29,0,0,0,14.64-13.76c.1-.22,0-.51-.16-.27C344.1,213.3,336.75,220.13,331.84,223.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5,202.55c-3.07,6-7.76,10.44-13.24,14.3-.07.05,0,.14.08.12,3.19-1.16,6.42-4,8.75-6.39a17.83,17.83,0,0,0,4.62-7.92C341.74,202.54,341.56,202.42,341.5,202.55Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson1WhatYouWillDo2);
export default __webpack_public_path__ + "static/media/person1WhatYouWillDo2.41c40cd691f05b0eec54bf6f4e646db1.svg";
export { ForwardRef as ReactComponent };